import { render, staticRenderFns } from "./WebSettingsAction.vue?vue&type=template&id=df2530f0&scoped=true"
import script from "./WebSettingsAction.vue?vue&type=script&lang=js"
export * from "./WebSettingsAction.vue?vue&type=script&lang=js"
import style0 from "./WebSettingsAction.vue?vue&type=style&index=0&id=df2530f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2530f0",
  null
  
)

export default component.exports